import { render } from "./SocialBoardCards.vue?vue&type=template&id=1e47525a"
import script from "./SocialBoardCards.vue?vue&type=script&lang=js"
export * from "./SocialBoardCards.vue?vue&type=script&lang=js"

import "./SocialBoardCards.vue?vue&type=style&index=0&id=1e47525a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__